/** @flow */

import { spawn } from "redux-saga/effects";
import managerDetailsSaga from "./manager-details";
import managerComplianceSaga from "./compliance";

export default function* managerSaga(): Generator<*, void, void> {
  yield spawn(managerDetailsSaga);
  yield spawn(managerComplianceSaga);
}
